import { Note } from "../note/Note"
import { User } from "../user/User"
import { ServiceFieldValueDetails } from "../service/ServiceFieldValueDetails"

export class OrderServiceDetails {
  id: number
  buildStepId: number
  completed: boolean
  completedByUser?: User
  completedDate?: string
  description: string
  name: string
  notes: Note[]
  price: number
  serviceFieldValues: ServiceFieldValueDetails[]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, buildStepId: number, completed: boolean, completedByUser: any, completedDate: string|undefined, description: string, name: string, notes: any, price: number, serviceFieldValues: any) {
    this.id = id
    this.buildStepId = buildStepId
    this.completed = completed
    this.completedByUser = completedByUser ? new User(completedByUser) : undefined
    this.completedDate = completedDate
    this.description = description
    this.name = name
    this.price = price
    this.serviceFieldValues = serviceFieldValues as ServiceFieldValueDetails[]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.notes = notes ? notes.map((n: any) => new Note(n.id, n.content, n.customerVisible, n.lastModifiedByUser, n.lastModifiedDate)) : []
  }
}